export interface PendingAuthItemLike {
  au_id?: number | string;
  au_company?: string;
  au_type: string;
  au_rmid?: number;
  au_ciid?: number;
  au_value: string;
  rm_name?: string;
  guest_name?: string;
  requester_name?: string;
  au_requester?: string;
  au_remarks?: string;
  au_request_date?: string;
  au_status?: string;
}

export const APPROVAL_PRESETS = [
  'Approved by Manager',
  'Verified with Guest',
  'Approved as per Policy',
  'Special Manager Override',
];

export const REJECTION_PRESETS = [
  'Rejected: Not approved',
  'Not approved as per policy',
  'Invalid request details',
  'Guest did not agree',
  'Exceeds authorized limit',
];

export const formatAuthType = (type: string): string => {
  switch (type) {
    case 'OpenToRollBack':
      return 'Rollback Checkout';
    case 'DeleteCheckin':
      return 'Delete Check-in';
    case 'RoomStatus':
      return 'Room Status';
    case 'GraceTime':
      return 'Grace Time';
    case 'ReduceTariff':
    case 'Discount':
      return 'Reduce Tariff';
    case 'RemoveExtraBed':
      return 'Waive Extra Bed';
    default:
      return type || 'Authorization';
  }
};

export const formatAuthValue = (auth: PendingAuthItemLike): string => {
  if (!auth) return '';
  if (auth.au_type === 'RoomStatus') {
    switch (auth.au_value) {
      case 'V':
        return 'Vacant (V)';
      case 'D':
        return 'Dirty (D)';
      case 'B':
        return 'Block (B)';
      case 'M':
        return 'Maintenance (M)';
      default:
        return auth.au_value;
    }
  }
  if (auth.au_type === 'OpenToRollBack') {
    return auth.au_value ? `Bill #${auth.au_value}` : 'Rollback Checkout';
  }
  if (auth.au_type === 'DeleteCheckin') {
    return auth.au_value ? `Folio #${auth.au_value}` : 'Delete Check-in';
  }
  if (auth.au_type === 'GraceTime') {
    return `${auth.au_value} hrs`;
  }
  if (auth.au_type === 'Discount' || auth.au_type === 'ReduceTariff') {
    return `₹${auth.au_value}`;
  }
  if (auth.au_type === 'RemoveExtraBed') {
    return 'Waive Extra Bed';
  }
  return auth.au_value || '-';
};

export const getAuthTypeColor = (type: string): { bg: string; text: string } => {
  switch (type) {
    case 'OpenToRollBack':
      return { bg: '#8B5CF6', text: '#FFFFFF' }; // Purple
    case 'DeleteCheckin':
      return { bg: '#EF4444', text: '#FFFFFF' }; // Red
    case 'RoomStatus':
      return { bg: '#F59E0B', text: '#FFFFFF' }; // Amber
    case 'GraceTime':
      return { bg: '#10B981', text: '#FFFFFF' }; // Emerald
    case 'ReduceTariff':
    case 'Discount':
      return { bg: '#3B82F6', text: '#FFFFFF' }; // Blue
    case 'RemoveExtraBed':
      return { bg: '#06B6D4', text: '#FFFFFF' }; // Cyan
    default:
      return { bg: '#6B7280', text: '#FFFFFF' }; // Gray
  }
};
